import { useEffect, useRef, useState } from "react";

interface TurnstileWidgetProps {
  onToken: (token: string) => void;
}

export function TurnstileWidget({ onToken }: TurnstileWidgetProps) {
  const isTest = import.meta.env.VITE_APP_ENV === "test";
  const siteKey = isTest
    ? undefined
    : (import.meta.env.VITE_TURNSTILE_SITE_KEY as string | undefined);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [manualToken, setManualToken] = useState("");

  useEffect(() => {
    if (!siteKey || !window.turnstile || !containerRef.current) {
      return undefined;
    }

    const widgetId = window.turnstile.render(containerRef.current, {
      sitekey: siteKey,
      appearance: "always",
      callback: (token) => onToken(token),
      "expired-callback": () => onToken(""),
    });

    return () => {
      window.turnstile?.remove(widgetId);
    };
  }, [onToken, siteKey]);

  if (!siteKey) {
    return (
      <div className="rounded-xl border border-dashed border-amber-300 bg-amber-50 p-4">
        <p className="text-sm font-medium text-ink">
          Aucun site key Turnstile.
        </p>
        <p className="mt-1 text-sm text-smoke">
          En local, colle un token de test.
        </p>
        <input
          className="text-field mt-3"
          placeholder="token-turnstile-dev"
          value={manualToken}
          onChange={(event) => {
            setManualToken(event.target.value);
            onToken(event.target.value);
          }}
        />
      </div>
    );
  }

  return <div ref={containerRef} />;
}
